import type { RootState } from "@src/store/rootState";
import { getVariationDraftErrors } from "@src/store/slices/experienceBuilder/common/selectors/getVariationDraftErrors";
import { hasVariationDraftChanges } from "@src/store/slices/experienceBuilder/common/selectors/hasVariationDraftChanges";

export function isVariationDraftApplicable(state: RootState) {
  const hasChanges = hasVariationDraftChanges(state);
  const errors = getVariationDraftErrors(state);
  return hasChanges && !errors;
}
